import axios from 'axios';
import store from '../redux/store';
import { signOut } from '../redux/actions/userActions';
import { alertShowThunk } from '../redux/reducers/alert';

export const stripeInstance = axios.create({
  baseURL: `https://api.stripe.com/v1`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
export const instance = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_HOST}/api/v1`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(function (config) {
  // @ts-ignore
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export enum ResultCodesEnum {
  Success = 200,
  Error = 401,
}
export enum ResultCodeForCaptchaEnum {
  CaptchaIsRequired = 10,
}

export type ResponseType<D = {}, RC = ResultCodesEnum> = {
  data: D;
  messages: Array<string>;
  resultCode: RC;
};
